// ============================================================
// gallery.js — Comportamiento de la galería de generaciones
// ============================================================
import { qs, qsa, on } from './utils.js';
import { toast } from './toast.js';
import { listHistory, deleteGeneration } from './api.js';

export async function initGallery() {
  const galleries = qsa('.gallery-grid');
  if (!galleries.length) return;

  // Comportamiento de selección, descarga y eliminación
  galleries.forEach((grid) => {
    on(grid, 'click', '.gen-card', (e, card) => {
      // Si el clic es en un botón de acción, no seleccionar
      if (e.target.closest('.gen-card-action')) return;

      qsa('.gen-card', grid).forEach((c) => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
    });

    on(grid, 'click', '[aria-label="Descargar"]', (e, btn) => {
      const url = btn.getAttribute('data-download-url');
      if (url) {
        const a = document.createElement('a');
        a.href = url;
        a.download = url.split('/').pop() || 'generacion';
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        toast({ message: 'Descarga iniciada', type: 'success' });
      } else {
        toast({ message: 'No hay ningún archivo generado para descargar todavía.', type: 'error' });
      }
    });

    on(grid, 'click', '.btn-del-gen', async (e, btn) => {
      e.stopPropagation();
      const id = btn.getAttribute('data-id');
      if (id && confirm('¿Deseas eliminar esta creación?')) {
        try {
          await deleteGeneration(id);
          const card = btn.closest('.gen-card');
          card?.remove();
          toast({ message: 'Creación eliminada correctamente', type: 'success' });
        } catch (err) {
          console.error('[Gallery] Error al eliminar:', err);
          toast({ message: 'Error al eliminar la creación', type: 'error' });
        }
      }
    });
  });

  // Pre-cargar creaciones recientes en la mesa de trabajo (Imágenes y Vídeo)
  const page = document.body.dataset.page;
  if (page === 'imagenes') {
    await populateWorkBench('#imageGallery', 'image');
  } else if (page === 'video') {
    await populateWorkBench('#videoGallery', 'video');
  }
}

export function createCardElement(item, type) {
  const card = document.createElement('div');
  card.className = `gen-card has-result ${type === 'video' ? 'is-video' : ''}`;
  card.style.position = 'relative';

  if (type === 'video') {
    const video = document.createElement('video');
    video.src = item.url || '';
    video.controls = true;
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
    video.style.borderRadius = '12px';
    card.appendChild(video);
  } else {
    const img = document.createElement('img');
    img.src = item.url || item.thumb || '';
    img.alt = item.title || item.prompt || 'Generación Vimo';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.borderRadius = '12px';
    card.appendChild(img);
  }

  const actions = document.createElement('div');
  actions.className = 'gen-card-actions';
  actions.style.cssText = 'position:absolute; top:12px; right:12px; display:flex; gap:8px; z-index:10;';
  actions.innerHTML = `
    <button class="gen-card-action" type="button" aria-label="Descargar" data-download-url="${item.url || ''}" style="background:rgba(0,0,0,0.6); color:white; border:none; width:34px; height:34px; border-radius:50%; display:flex; align-items:center; justify-content:center; cursor:pointer;">
      <i class="bi bi-download"></i>
    </button>
    <button class="gen-card-action btn-del-gen" type="button" aria-label="Eliminar" data-id="${item.id}" style="background:rgba(239,68,68,0.85); color:white; border:none; width:34px; height:34px; border-radius:50%; display:flex; align-items:center; justify-content:center; cursor:pointer;">
      <i class="bi bi-trash"></i>
    </button>
  `;
  card.appendChild(actions);
  return card;
}

async function populateWorkBench(gridSelector, type) {
  const grid = qs(gridSelector);
  if (!grid) return;

  grid.innerHTML = ''; // Limpiar cualquier tarjeta previa

  try {
    const items = await listHistory();
    const filteredItems = items.filter(item => item.type === type);

    if (filteredItems.length > 0) {
      filteredItems.forEach(item => {
        const card = createCardElement(item, type);
        grid.appendChild(card);
      });
    } else {
      grid.innerHTML = `
        <div class="gallery-empty-state" style="grid-column: 1 / -1; text-align: center; padding: 50px 20px; color: #94A3B8; background: rgba(255,255,255,0.02); border-radius: 16px; border: 1px dashed rgba(255,255,255,0.1);">
          <i class="bi ${type === 'video' ? 'bi-camera-reels' : 'bi-image'}" style="font-size: 40px; display: block; margin-bottom: 12px; color: #a855f7;"></i>
          <p style="font-size: 16px; font-weight: 700; margin-bottom: 6px; color: #F8FAFC;">Aún no tienes ${type === 'video' ? 'vídeos' : 'imágenes'} creadas</p>
          <span style="font-size: 13.5px; color: #94A3B8;">Escribe tu prompt en el panel inferior para generar tu primera creación.</span>
        </div>
      `;
    }
  } catch (err) {
    console.warn(`[Workbench] No se pudieron cargar los datos del historial para ${type}:`, err);
  }
}
